import { CanDeactivateFn } from '@angular/router';
import { TaskEditComponent } from './task-edit.component';

/** Stops navigation away from a task page while its timing draft holds unsaved edits, unless the admin confirms. */
export const unsavedTimingChangesGuard: CanDeactivateFn<TaskEditComponent> = (component) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  return component.confirmLeave();
};
